import { render, staticRenderFns } from "./AppDinamicForm.vue?vue&type=template&id=b8aa4402"
import script from "./AppDinamicForm.vue?vue&type=script&lang=js"
export * from "./AppDinamicForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports